import { NgModule } from '@angular/core';
import { NgSimpleSeoComponent } from './ng-simple-seo.component';
import { NgSimpleSeoService } from './ng-simple-seo.service';

@NgModule({
  providers: [NgSimpleSeoService],
  declarations: [NgSimpleSeoComponent],
  imports: [],
  exports: [NgSimpleSeoComponent],
})
export class NgSimpleSeoModule {}
